<template>
  <v-layout v-if="qrReader" text-xs-center column>
    <v-flex xs12>
      <v-alert :value="error" type="warning">{{ error }}</v-alert>
      <v-alert :value="this.isUrl" type="warning">{{ $t('qrNotUrl') }}</v-alert>
    </v-flex>
    <v-flex xs12 v-if="!error">
      <qrcode-stream @decode="onDecode" @init="onInit" />
    </v-flex>
  </v-layout>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  props: {
    qrReader: Boolean
  },
  components: {
    QrcodeStream
  },
  data() {
    return {
      isUrl: false,
      error: ""
    };
  },
  methods: {
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = this.$i18n.t("errors.cameraAccess");
        } else if (error.name === "NotFoundError") {
          this.error = this.$i18n.t("errors.cameraNotFound");
        } else if (error.name === "NotSupportedError") {
          this.error = this.$i18n.t("errors.cameraNotSupp");
        } else if (error.name === "NotReadableError") {
          this.error = this.$i18n.t("errors.cameraNotRead");
        } else if (error.name === "OverconstrainedError") {
          this.error = this.$i18n.t("errors.cameraOverconst");
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = this.$i18n.t("errors.cameraStramApi");
        }
      }
    },
    onDecode(url) {
      if (url.startsWith("http")) {
        window.location.href = url;
      } else {
        return (this.isUrl = true);
      }
    }
  }
};
</script>